export default {
  props: {
    classes: {
      type: Array,
      default: () => [],
    },
    name: String,
    label: String,
    id: String,
    checked: Boolean,
    inputFunc: {
      type: Function,
      default: () => null,
    },
    properties: {
      type: Object,
      default: () => {},
    },
    datasets: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return { isChecked: this.checked };
  },
  methods: {
    buildClasses() {
      const result = [];

      if (this.classes) {
        result.concat(this.classes);
      }

      return result;
    },
    createDataSets() {
      const result = {};

      if (this.datasets) {
        Object.keys(this.datasets).forEach((key) => {
          return (result[`data-${key}`] = this.datasets[key]);
        });
      }

      return result;
    },
  },
  watch: {
    checked() {
      this.isChecked = this.checked;
    },
  },
};
